module.exports = "/assets/ba0eb8a395c1b10456c07d5bf379bb64.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DP.png
// module id = 1309
// module chunks = 0